<bw-action-article-legacy
  class="autosave-settings"
  [brightsideWebFb]="{event_name: 'autosave_settings'}">
  <div header-actions>
    <ui-nav-exit-back
      [trackingDetail]="{ event_name: 'autosave_settings' }"
      (exitActionHandler)="routeUserOnBack()"
    ></ui-nav-exit-back>
  </div>
  <div header-title>
    <typography-legacy title-large color="var(--primary-text)">
      {{ 'AUTOSAVE_SETTINGS_TITLE' | translate }}
    </typography-legacy>
  </div>
  <div content-section>
    <div *ngIf="(currentAutosaveInfo$|async) as autosave;else spinner"
         class="autosave-settings__content-section">
      <typography-legacy
        *ngIf="(autoSaveOnOff$|async) || autosave.autoSaveSchedule.status === 'notStarted';else descOff"
        text-small-regular
        color="var(--secondary-text)"
        class="mb-sm">
        {{ 'AUTOSAVE_SETTINGS_DESC' | translate }}
      </typography-legacy>
      <ng-template #descOff>
        <typography-legacy
          text-small-regular
          color="var(--secondary-text)"
          class="mb-sm">
          {{ 'AUTOSAVE_SETTINGS_DESC_OFF' | translate }}
        </typography-legacy>
      </ng-template>
      <div
        class="autosave-settings__animation-wrapper"
        [@openClose]="(autoSaveOnOff$|async) || autosave.autoSaveSchedule.status === 'notStarted' ? 'open' : 'closed'">
        <bw-new-currency-select-legacy
          [preselectedValue]="(autoSaveAmountSelected$|async)"
          (selectionChanged)="autosaveAmount($event)"
          [amountOptions]="options$|async"
          [precision]="0"
          [forcedMaxValue]="9999">
          <div> {{ 'AUTOSAVE_SETTINGS_PAYCHECK_AMOUNT' | translate }}</div>
        </bw-new-currency-select-legacy>
      </div>
      <bw-cell-legacy
        [labelSubLeft]="
           autosave.autoSaveSchedule.status !== 'notStarted'
          ? ('AUTOSAVE_SETTINGS_NEXT_PAYCHECK'|translate)
          : ('AUTOSAVE_SETTINGS_START_DATE'|translate)
          "
        [labelRight]="autosave.nextAvailableDate | date:'MMMM d, yyyy'">
      </bw-cell-legacy>
      <bw-cell-legacy
        *ngIf="autosave.autoSaveSchedule.status !== 'notStarted'"
        [labelSubLeft]="(autoSaveOnOff$|async) ? ('AUTOSAVE_SETTINGS_TOGGLE_ON'|translate) : ('AUTOSAVE_SETTINGS_TOGGLE_OFF'|translate)"
        [showToggleSwitch]="true"
        [switchChecked]="autoSaveOnOff$|async"
        (switchToggled)="toggleAutoSaveFeature($event)">
      </bw-cell-legacy>
      <typography-legacy text-small-regular color="var(--secondary-text)" class="mt-sm">
        <div *ngIf="autosave.autoSaveSchedule.status !== 'notStarted'" [innerHTML]="
        'AUTOSAVE_SETTINGS_AVAILABLE_PAYROLL_DATE' | translate:
        {date: (autosave.autoSaveSchedule.nextDepositDate | date:'MMMM d, yyyy') }">
        </div>
      </typography-legacy>
    </div>
  </div>
  <div footer-actions class="flex-row flex-item-flexible space-between">
    <div class="flex-row row-reverse" >
      <button
        *ngIf="(currentAutosaveInfo$|async)"
        bw-button-legacy
        type="submit"
        [brightsideWebFb]="{ event_name: 'autosave_settings'}"
        [disabled]="(isOkToPost$|async) === false"
        (click)="onSubmit()"
        [processing]="processing$|async"
      >
        {{ 'AUTOSAVE_SETTINGS_CTA1' | translate }}
      </button>
    </div>
  </div>
</bw-action-article-legacy>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
